import { MNSproCloudApi } from '..';
import { FeatureUpdateEntity } from '../api/v2';

export class FeaturesService {
  static async getAllFeatures(authToken: string, organizationId: string) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.FeaturesApiFactory(config);
    const result = await api.getAllFeatures(organizationId);

    return result.data;
  }

  static async hasFeatureFlag(
    authToken: string,
    organizationId: string,
    featureFlag: string,
  ): Promise<boolean> {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.FeaturesApiFactory(config);
    const result = await api.hasFeatureFlag(organizationId, featureFlag);
    return result.data;
  }

  static async updateFeatures(
    authToken: string,
    organizationId: string,
    features: FeatureUpdateEntity[],
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.FeaturesApiFactory(config);
    const result = await api.updateFeatures(organizationId, {
      organizationId,
      features,
    });

    return result.data;
  }
}
